import { DialogTitle, DialogContent, DialogActions, Button } from '@mui/material';
import { ExtendedList } from '@procureai/ui-mui';
import { PropsWithChildren } from 'react';
import { useTranslation } from 'react-i18next';

import { DialogActionsLayout } from '../DialogWizard/components/DialogActionsLayout/DialogActionsLayout';
import { I18nNamespace } from '~/common/types';

interface GuidedDialogProps {
  title?: string;
  closeDialog: () => void;
}
export const GuidedDialog = ({ title, closeDialog, children }: GuidedDialogProps & PropsWithChildren) => {
  const { t } = useTranslation(I18nNamespace.common, { keyPrefix: 'DialogWizard.general.actions' });
  return (
    <>
      {title && <DialogTitle>{title}</DialogTitle>}
      <DialogContent>
        <ExtendedList sx={{ flexDirection: 'row', display: 'flex', gap: 4 }}>{children}</ExtendedList>
      </DialogContent>
      <DialogActions>
        <DialogActionsLayout left={<Button onClick={() => closeDialog()}>{t('cancel')}</Button>} />
      </DialogActions>
    </>
  );
};
